import axios from 'axios';
import { Session } from '../../models/Session';
import { strings } from '../../resources/strings';
import { StorageService } from '../Storage/StorageService';
import { IHttpService } from './IHttpService';

export class HttpService implements IHttpService {

  constructor(private storageService: StorageService) {
  }

  extractRefreshToken = (response: any) => {
    const refreshToken = response?.data?.refreshToken;
    if (refreshToken) {
      console.log('refreshing token...');
      const session = this.storageService.get<Session>(strings.StorageSessionKey);
      if (session) {
        session.token = refreshToken;
        session.date = new Date();
        session.sessionExpiresAtUtcDate = response?.data?.sessionExpiresAtUtcDate ? new Date(response?.data?.sessionExpiresAtUtcDate) : null;
        session.sessionExpiresAtAmericaSaoPauloDate = response?.data?.sessionExpiresAtAmericaSaoPauloDate ? new Date(response?.data?.sessionExpiresAtAmericaSaoPauloDate) : null;
        this.storageService.set(strings.StorageSessionKey, session);
      }
    }
  }
  
  get = async <TResult>(url: string) => {
    const promise: Promise<TResult> = new Promise(async (resolve, reject) => {
      try {
        const response = await axios.get<TResult>(url, this.getConfig())
        this.extractRefreshToken(response);
        resolve(response.data)
      } catch (error) {
        reject(error)
      } finally {
      }
    });
    return promise;
  }

  post = async <TResult, TData>(url: string, data: TData, multipartFormData: boolean = false) => {
    const promise: Promise<TResult> = new Promise(async (resolve, reject) => {
      try {
        const response = await axios.post<TResult>(url, data, this.getConfig(multipartFormData))
        this.extractRefreshToken(response);
        resolve(response.data)
      } catch (error) {
        reject(error)
      } finally {
      }
    });
    return promise;
  }

  postToDownloadFile = <TData>(url: string, data: TData) => {
    return axios.request({
      url: url,
      method: 'POST',
      responseType: 'blob',
      headers: this.getConfig().headers,
      data: data
    });
  }

  put = async <TResult, TData>(url: string, data: TData) => {
    const promise: Promise<TResult> = new Promise(async (resolve, reject) => {
      try {
        const response = await axios.put<TResult>(url, data, this.getConfig())
        this.extractRefreshToken(response);
        resolve(response.data)
      } catch (error) {
        reject(error)
      } finally {
      }
    });
    return promise;
  }

  patch = async <TResult, TData>(url: string, data: TData) => {
    const promise: Promise<TResult> = new Promise(async (resolve, reject) => {
      try {
        const response = await axios.patch<TResult>(url, data, this.getConfig())
        this.extractRefreshToken(response);
        resolve(response.data)
      } catch (error) {
        reject(error)
      } finally {
      }
    });
    return promise;
  }

  delete = async <TResult, TData = undefined>(url: string, data?: TData) => {
    const promise: Promise<TResult> = new Promise(async (resolve, reject) => {
      try {
        const response = await axios.delete<TResult>(url, {
          ...this.getConfig(),
          data,
        })
        this.extractRefreshToken(response);
        resolve(response.data)
      } catch (error) {
        reject(error)
      } finally {
      }
    });
    return promise;
  }

  private getConfig = (multipartFormData: boolean = false) => {
    const session = this.storageService.get<Session>(strings.StorageSessionKey);
    if (!session) return {};
    return {
      headers: {
        "Authorization": `Bearer ${session.token}`,
        "Content-Type": multipartFormData ? 'multipart/form-data' : 'application/json'
      }
    };
  }
}
